import { getCenter } from "ol/extent";
import { OptionsMap } from "./../library/ebw-map-angular/model/optionsMap.model";
import { RouterService } from "./../servizi/router.service";
import {
  Component,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnDestroy,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef
} from "@angular/core";
import BaseLayer from "ol/layer/Base";
import ConfigMappaJSON from "src/assets/config/config-mappa.dev.json";
import ConfiGlobaleJson from "src/assets/config/config-globale.dev.json";
import { IConfigMappa } from "../library/ebw-map-angular/model/config-mappa.model";

import { MapComponent } from "../library/ebw-map-angular/map.component";
import { MappaService } from "../servizi/mappa/mappa.service";

import {
  PosizioneLayer,
  TipoLayer
} from "../library/ebw-map-angular/service/map.service";
import { combineLatest, merge, Subscription } from "rxjs";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { GeoJSON } from "ol/format";
import { MapService } from "../library/ebw-map-angular/service/map.service";
import { Feature } from "ol";
import { EbwModalService } from "src/app/library/ebw-modals-angular/ebw-modal.service";
import { UtilsService } from "src/app/servizi/utils.service";
import { GestioneLoginService } from "src/app/servizi/login/gestione-login.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { Layer, Vector, Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource, XYZ } from "ol/source";
import { Fill, Stroke, Style, RegularShape, Text, Icon } from "ol/style";
import { Point, LineString, Circle, SimpleGeometry } from "ol/geom";
import { getPointResolution, transform } from "ol/proj";
import { METERS_PER_UNIT } from "ol/proj/Units";
import ResizeObserver from "resize-observer-polyfill";
import Geometry from "ol/geom/Geometry";
import { IConfigGlobale } from "../modelli/config-globale.model";
// import { MapUtilsService } from "../library/ebw-map-angular/service/map-utils.service";
import { distinctUntilChanged, filter, map, mapTo } from "rxjs/operators";
import { GestioneUtentiService } from "./../servizi/utenti/gestione-utenti.service";

import {
  AnalysisDataLoaderService,
  analysisQueryPointsSourceI
} from "../servizi/analysis/analysis-data-loader.service";
import { AnalysisUtilsService } from "./right-sidebar/analysis-utils.service";
import { ReportBtsComponent } from "../modali/report-bts/report-bts.component";
import { ReportOmiComponent } from "../modali/report-omi/report-omi.component";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ToolDisegnoEnabledToolsInterface } from "../library/ebw-map-angular/model/toolDisegno.model";
import {
  createStaticImageLayerSource,
  extentFromWorldInfo
} from "../home/object-info/create-static-image-layer-source";
import { WorldService } from "../servizi/nam/world.service";
import {
  ConfigApiInterface,
  WorldInfoInterface
} from "../home/object-info/model/config-api-response.interface";
import { DynamicConfigService } from "../servizi/nam/dynamic-config.service";
import { ProjectService } from "../servizi/nam/project.service";
import { NamSelectedObjectService } from "../servizi/nam/nam-object-selected.service";
import { EditFeatureService } from "../servizi/nam/edit-feature.service";
import { NamService } from "../servizi/nam/nam.service";
import { LoaderService } from "../interceptor/loader.service";
import ContextProvider from "../servizi/contextProvider";
import TileLayer from "ol/layer/Tile";
import { url } from "inspector";
import { TemplateService } from "../servizi/nam/template.service";
import { AnalysisPropertyModalComponent } from "../analysis/analysis-property-modal/analysis-property-modal.component";
import IconOrigin from "ol/style/IconOrigin";
import IconAnchorUnits from "ol/style/IconAnchorUnits";
import { AnalysisLegendService } from "../servizi/analysis/analysis-legend.service";

/** Componente Mappa (utilizza  il componente EBW-MAP) */
@Component({
  selector: "app-mappa",
  templateUrl: "./mappa.component.html",
  styleUrls: ["./mappa.component.scss"]
})
export class MappaComponent implements AfterViewInit, OnDestroy, OnInit {
  /** Variabile che conterrà le configurazioni della mappa */
  configMappa: IConfigMappa;
  configGlobale: IConfigGlobale;

  //marker preso dal file di configurazione
  MARKER_ROSSO = "MarkerRosso";

  // Coordinate per centrare la mappa su Roma
  customCenterCoords;

  /** Sottoscrizione agli eventi lanciati dal routing verso la mappa */
  initSubscription: Subscription;
  initSubscriptionData: Subscription;

  /** Bottone per tornare alla pagina di ricerca */
  showBackButton = false;

  /* Booleano per aprire un solo report alla volta dalla mappa */
  reportIsOpen: boolean = false;

  /** */
  rilievoOverlay: VectorLayer;

  /** Observer per resize della mappa */
  sizeObserver: ResizeObserver;

  /** Booleano per controllare se provengo dalla login oppure no */
  login: boolean = false;

  @Output() geometryChanged = new EventEmitter<any>();

  /** Evento emesso nel caso della gestione delle ordinanze e dei vincoli, quando è stata confermata una geometria dal tool di disegno */
  @Output() toolDisegnoElementoConfermatoMappaEmitter = new EventEmitter<any>();

  /** Nella gestione delle ordinanze e dei vincoli serve per chiudere la modale contenente la mappa quando viene premuto 'Annulla' nel pannello coordinate del tool di disegno */
  @Output() toolDisegnoChiusuraMappaEmitter = new EventEmitter<any>();

  /** Dati in arrivo */
  @Input() mapInputData: any = {};

  // @Input() geometrieIngiunzioneStato = undefined;

  /** Visibilità controlli mappa */
  // @Input() controlliMappaAttivi = true;

  /** Variabile per impostare l'altezza della mappa */
  @Input() altezza = { height: "calc(100vh - 72px)" };
  @Input() checkQueryString = true;

  /** Riferimento alla mappa generica */
  @ViewChild("mappa", { static: false }) mappa: MapComponent;

  /** Dimensione della sidebar. valori : 400px per 'small' || 800px per 'large' */
  // Default small 400px
  // Il componente RicercaAnalisi ha bisogno di una sidebar più grande
  SMALL_WIDTH = { width: "400px" };
  LARGE_WIDTH = { width: "50vw" };

  SMALL_WIDTH_INT = "500px";
  LARGE_WIDTH_PERC = "50vw"; // TODO come posso fare con la percentuale?

  mapWidthType = "small";

  rightSidebarSize;
  larghezzaSidebar;

  /** Indica se il sidebar laterale è aperto o no. */
  rightSBarOpened: boolean = false;

  /** Controlla visibilita del menu a destra */
  rightMenuEnabled: boolean;

  /** Enable/Disable functionalities */
  controlliMappaAttivi = false;
  mapSearchPanelActive = false;
  mapBaseLayersActive = false;
  previewMapActive = false;
  infoMapActive = false;
  drawingToolActive = false;
  reprChoiceActive = false;
  transformCoordsActive = false;
  legendActive = false;

  subs: Subscription[] = [];

  public options: OptionsMap;

  /** Costruttore del componente */
  constructor(
    private elementRef: ElementRef,
    private route: ActivatedRoute,
    private servizioMappa: MapService,
    public utils: UtilsService,
    public loginService: GestioneLoginService,
    public userService: GestioneUtentiService,
    private modal: NgbModal,
    private ebwModalService: EbwModalService,
    private wrapperMapService: MappaService,
    private routerSrv: RouterService,
    // private mapUtilsService: MapUtilsService,
    private router: Router,
    private gestioneUtentiService: GestioneUtentiService,
    private analysisDataLoaderService: AnalysisDataLoaderService,
    private analysisUtilsService: AnalysisUtilsService,
    private loginServ: GestioneLoginService,
    private http: HttpClient,
    private worldService: WorldService,
    private dynamicConfigService: DynamicConfigService,
    private projectService: ProjectService,
    private namSelectedObjectService: NamSelectedObjectService,
    private editGeometryService: EditFeatureService,
    private templateService: TemplateService,
    private namService: NamService,
    private loaderService: LoaderService,
    private modalService: NgbModal,
    private analysisLegendService: AnalysisLegendService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    this.configMappa = ConfigMappaJSON as unknown as IConfigMappa;

    this.configGlobale = ConfiGlobaleJson as IConfigGlobale;
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // You only receive NavigationEnd events
        //  console.log("mappacomponent router navigation end: ", event);
        if (event?.url?.includes("sidebar")) {
          this.rightSBarOpened = true;
        } else {
          this.rightSBarOpened = false;
        }
        if (!event?.url?.includes("dettaglio-analisi")) {
          if (this.mappa?.layerAnalysis)
            (this.mappa.layerAnalysis as VectorLayer).getSource().clear();
          this.removeAllQueryPointFromLayerAnalysisQueryPoints();
        }
      });
  }

  ngOnInit() {
    this.rightSidebarSize = this.SMALL_WIDTH;
    this.larghezzaSidebar = this.SMALL_WIDTH_INT;

    this.wrapperMapService.updateDataWithSameRoute.subscribe((data) =>
      this.routerSubscribe(data)
    );
    this.initSubscriptionData = this.route.data.subscribe((data) =>
      this.routerSubscribe(data)
    );
    // this.mapUtilsService.configGlobale = this.configGlobale;

    this.rightMenuEnabled = ContextProvider.getContext().rightMenu;
    this.wrapperMapService.toggleSidebar.subscribe((data) =>
      this.toggleSidebarAnalysis(data)
    );

    if (ContextProvider.getContext().header) {
      this.altezza = { height: "calc(100vh - 72px)" };
    } else {
      this.altezza = { height: "100vh" };
    }

    /** Per illuminare le features */
    this.subs.push(this.wrapperMapService.illuminaFeatureSub.subscribe((data) => {
      // console.log("+++++ 2- MAPPA.C ILLUMINA SUBSCRIPTION");
      this.illuminaFeature(data);
    }));

    /** Per spegnere le features */
    this.subs.push(this.wrapperMapService.spegniFeatureSub.subscribe((data) => {
      // console.log("------ 2- MAPPA.C SPEGNI SUBSCRIPTION");
      this.spegniFeature(data);
    }));

    /** Per Aprire Google Street View da un qualunque componente del portale */
    this.subs.push(this.wrapperMapService.toggleStreetViewSubject.subscribe((object) => {
      this.toggleStreetView(object);
    }));

    this.subs.push(this.wrapperMapService.isStreetViewVisibleSubject.subscribe((data) => {
      this.isStreetViewVisible(data);
    }));

    this.subs.push(this.wrapperMapService.gestisciToolDisegnoSubject.subscribe((data) => {
      this.gestisciToolDisegno(
        data?.obj,
        data?.type,
        data?.defaultTool,
        data?.closeAll,
        data?.data,
        data?.enabledTools);
    }));

    this.subs.push(this.wrapperMapService.chiudiToolDisegnoSubjectExtSubject.subscribe((data: Boolean) => {
      this.chiudiToolDisegnoDaComponenteEsterno(data);
    }))

    // Il componente RicercaAnalisi ha bisogno di una sidebar più grande
    this.subs.push(this.wrapperMapService.setRightSidebarWidthSubject.subscribe((width) => {
      if (width == "large") {
        this.mapWidthType = "large";
        this.rightSidebarSize = this.LARGE_WIDTH;
        this.larghezzaSidebar = this.LARGE_WIDTH_PERC;
      } else if (!width || width === "small") {
        this.mapWidthType = "small";
        this.rightSidebarSize = this.SMALL_WIDTH;
        this.larghezzaSidebar = this.SMALL_WIDTH_INT;
      }

      this.changeDetectorRef.detectChanges();
    }));


    // IW-139 Fix Sicurezza Visibilità Livello Analisi
    // Utenti e gruppi per i quali non deve essere mostrato il layer AnalysisAreas
    const LIMITED_USERS = ['eagleprojects'];
    const LIMITED_GROUPS = ['EagleProjects'];

    let userProps = this.gestioneUtentiService.userGetProperties();

    // Check se l'utente loggato è uno di quelli presenti in LIMITED_USERS
    let isLimitedUser = LIMITED_USERS.includes(userProps.username);

    // Check se uno dei gruppi dell'utente loggato è uno di quelli presenti in LIMITED_GROUPS
    let isLimitedGroups = userProps.groups.some(group => LIMITED_GROUPS.includes(group.name));

    if (isLimitedUser || isLimitedGroups) {
      // WMSLAYERS - Rimuove l'oggetto con titolo 'AnalysisAreas' da wmsLayers
      this.configMappa.wmsLayers = this.configMappa?.wmsLayers.filter(
        (layer) => layer.titolo !== "AnalysisAreas"
      );

      // SCELTA RAPPRESENTAZIONE - Cicla su sceltaRappresentazione per cercare l'oggetto con group_name: 'INWIT_L'
      this.configMappa?.sceltaRappresentazione.forEach((item) => {
        item.content.forEach((contentItem) => {
          // Se group_name === "INWIT_L" rimuovo le AnalysisAreas dalla configurazione aggiornando direttamente le proprietà di contentItem
          if (contentItem.group_name === "INWIT_L") {
            contentItem.title = "Layers INWIT";
            contentItem.type = "checkbox";
            contentItem.values = ["StazioniBTS"];
            contentItem.labels = ["Stazioni BTS"];
            contentItem.checked = [false];
          }
        });
      });

      // LEGENDA
      // Cicla su legenda e content per cercare l'oggetto con group_name 'INWIT_L'
      this.configMappa?.legenda.forEach(tab => {
        tab.content.forEach(contentItem => {
          if (contentItem.group_name === "INWIT_L") {
            // Filtra l'array layers per rimuovere l'oggetto con layer_name 'AnalysisAreas'
            contentItem.layers = contentItem.layers.filter(layer => layer.layer_name !== "AnalysisAreas");
          }
        });
      });
    }


    this.configureMap();

    // Il NAM non usa la Legenda, INWIT si
    if (this.configGlobale.context.application !== 'NAM') {
      this._getAnalysisLegend();
    }
  }



  private subscriptions() {
    this.subs.push(
      this.analysisDataLoaderService.analysisGeometry$.subscribe({
        next: (geom) => {
          if (geom !== null) {
            const feature = new Feature({ geometry: geom });
            feature.setStyle(
              this.servizioMappa.buildFeatureStyleFromId("BlueFill")
            );
            feature.setId(1);

            (this.mappa.layerAnalysis as VectorLayer).getSource().clear();

            this.mappa.aggiungiFeature(this.mappa.layerAnalysis, feature);
            this.mappa.mappaOpenLayer.getView().fit(geom);
          } else {
            (this.mappa.layerAnalysis as VectorLayer).getSource().clear();

            // Roma
            // this.mappa.viewMappa.setCenter(this.customCenterCoords);

            // if (this.mappa.viewMappa.getZoom() > 6) {
            //   this.mappa.viewMappa.setZoom(6);
            //}
          }
        }
      })
    );

    // Per mostrare più poligoni sulla mappa
    this.subs.push(
      this.analysisDataLoaderService.analysisGeometries$.subscribe({
        next: (geoms) => {
          if (geoms !== null && geoms.length > 0) {
            (this.mappa.layerAnalysis as VectorLayer).getSource().clear();

            geoms.forEach((geom) => {
              const polygonFeature = new Feature({ geometry: geom });

              // Centro del poligono
              const feature = new Feature({
                geometry: new Point(
                  getCenter(polygonFeature.getGeometry().getExtent())
                )
              });
              feature.setStyle(
                this.servizioMappa.buildFeatureStyleFromId(this.MARKER_ROSSO)
              );

              // Stile Area Rossa
              //feature.setStyle(this.servizioMappa.buildFeatureStyleFromId("RedFill"));

              // NOTE: usare getProperties per usare tutte le proprietà del polygon
              feature.setId(geom.get("analysis_id"));
              this.mappa.aggiungiFeature(this.mappa.layerAnalysis, feature);
            });

            let extent = (this.mappa.layerAnalysis as VectorLayer)
              .getSource()
              .getExtent();
            this.mappa.mappaOpenLayer.getView().fit(extent);

            // zoom indietro con funzione -
            this.wrapperMapService.diminiuisciZoom();
          } else {
            if (this.mappa && this.mappa.layerAnalysis) {
              (this.mappa.layerAnalysis as VectorLayer).getSource().clear();
            }

            // Roma
            this.mappa.viewMappa.setCenter(this.customCenterCoords);

            if (this.mappa.viewMappa.getZoom() > 6) {
              this.mappa.viewMappa.setZoom(6);
            }
          }
        }
      })
    );

    this.subs.push(
      this.analysisDataLoaderService.analysisQueryPoints$.subscribe({
        next: (mappaAnalysisQueryPoints) => {
          // console.log("mappaAnalysisQueryPoints", mappaAnalysisQueryPoints);
          switch (mappaAnalysisQueryPoints.action) {
            case "add":
              this.addQueryPointsTolayerAnalysisQueryPoints(
                mappaAnalysisQueryPoints
              );
              break;
            case "remove":
              this.removeQueryPointsFromLayerAnalysisQueryPoints(
                mappaAnalysisQueryPoints
              );
              break;
            case "removeAll":
              this.removeAllQueryPointFromLayerAnalysisQueryPoints();
              break;
            case "removeKML":
              this.removeKMLQueryMarkersFromLayerAnalysisQueryPoints();
              break;
            case "fit":
              mappaAnalysisQueryPoints.query.forEach((qp) => {
                const pointFeature = (
                  (
                    this.mappa.layerAnalysisQueryPoints as VectorLayer
                  ).getSource() as VectorSource
                ).getFeatureById(qp.id);
                if (pointFeature) {
                  this.mappa.mappaOpenLayer
                    .getView()
                    .fit(pointFeature.getGeometry() as Point);
                }
              });
              break;
            default:
              break;
          }
        }
      })
    );
    this.subs.push(
      merge(
        this.namSelectedObjectService.selectedObjectToEditWithDetailsAndGeometry$.pipe(
          map((s) => ({ ...s, action: "edit" }))
        ),
        this.namSelectedObjectService.selectedObjectToHighlightWithDetailsAndGeometry$.pipe(
          map((s) => ({ ...s, action: "highlight" }))
        ),
        this.namSelectedObjectService.deselectedObject$.pipe(
          map((s) => ({ ...s, action: "clear" }))
        )
      ).subscribe((o: any) => {
        (this.mappa.layerDisegno as VectorLayer).getSource().clear();
        switch (o.action) {
          case "clear":
            break;
          case "edit":
            console.log("mappa selectedObject with geometry, EDIT", o);
            (this.mappa.layerDisegno as VectorLayer).getSource().clear();
            this.editGeometryService.addEditGeometryToMap(o);
            break;
          case "highlight":
            const geometry = new GeoJSON().readGeometry(
              o.result.features[0].geometry
            );
            console.log(o);

            const feature = new Feature({ geometry: geometry });
            const featureStyle = "YellowPoint";

            feature.setStyle(
              this.servizioMappa.buildFeatureStyleFromId(featureStyle)
            );
            feature.setId(o.result.features[0].id);

            this.mappa.aggiungiFeature(this.mappa.layerDisegno, feature);
            this.mappa.mappaOpenLayer
              .getView()
              .fit(geometry as SimpleGeometry, { maxZoom: 5, duration: 500 });
            break;
          default:
            break;
        }
      })
    );

    if (ContextProvider.getContext().context.application == "NAM") {
      this.subs.push(
        // Subscribe to world info changes.
        combineLatest([
          this.namService.getApiConfiguration(),
          this.worldService.onChange
        ]).subscribe(([apiConfig, worldInfo]) => {
          this.setSourceToStaticImageLayer(
            apiConfig,
            worldInfo,
            this.worldService.currentUrn
          );
        })
      );
    }

    // Il NAM non usa la Legenda, INWIT si
    if (this.configGlobale.context.application !== 'NAM') {
      this.subs.push(
        this.analysisLegendService.analysisLegendUpdateRequest$.subscribe({
          next: () => {
            this._getAnalysisLegend();
          }
        })
      )
    }

  }

  private removeAllQueryPointFromLayerAnalysisQueryPoints() {
    if (this.mappa?.layerAnalysisQueryPoints) {
      (
        (
          this.mappa.layerAnalysisQueryPoints as VectorLayer
        ).getSource() as VectorSource
      )
        .getFeatures()
        .forEach((el) => {
          if (el.getProperties().kml_marker != true) {
            const overlay = el.get("overlay");
            if (!!overlay) {
              this.mappa.deleteOverlay(overlay);
            }
          }
        });
      (this.mappa.layerAnalysisQueryPoints as VectorLayer).getSource().clear();
    }
  }

  private removeQueryPointsFromLayerAnalysisQueryPoints(
    mappaAnalysisQueryPoints: analysisQueryPointsSourceI
  ) {
    mappaAnalysisQueryPoints.query.forEach((qp) => {
      const pointFeature = (
        (
          this.mappa.layerAnalysisQueryPoints as VectorLayer
        ).getSource() as VectorSource
      ).getFeatureById(qp.id);

      if (!!pointFeature && pointFeature.getProperties().kml_marker != true) {
        const overlay = pointFeature.get("overlay");
        if (!!overlay) {
          this.mappa.deleteOverlay(overlay);
        }

        (this.mappa.layerAnalysisQueryPoints as VectorLayer)
          .getSource()
          .removeFeature(pointFeature);
        (this.mappa.layerAnalysisQueryPoints as VectorLayer)
          .getSource()
          .refresh();
      }
    });
  }

  private removeKMLQueryMarkersFromLayerAnalysisQueryPoints() {
    const kml_markers = (this.mappa.layerAnalysisQueryPoints as VectorLayer)
      .getSource()
      .getFeatures()
      .filter((feature) => {
        const properties = feature.getProperties();
        return !!properties.kml_marker;
      });

    kml_markers.forEach((pointFeature) => {
      if (!!pointFeature) {
        const overlay = pointFeature.get("overlay");
        if (!!overlay) {
          this.mappa.deleteOverlay(overlay);
        }

        (this.mappa.layerAnalysisQueryPoints as VectorLayer)
          .getSource()
          .removeFeature(pointFeature);
        (this.mappa.layerAnalysisQueryPoints as VectorLayer)
          .getSource()
          .refresh();
      }
    });
  }

  private addQueryPointsTolayerAnalysisQueryPoints(
    mappaAnalysisQueryPoints: analysisQueryPointsSourceI
  ) {
    mappaAnalysisQueryPoints.query.forEach((qp) => {
      if (qp?.point?.crs?.properties?.name) {
        const point = new GeoJSON().readGeometry(qp.point, {
          dataProjection: qp.point.crs.properties.name,
          featureProjection: MapService.EPSG_3857_KEY
        }) as Point;

        const feature = new Feature({ geometry: point });
        const featureStyle =
          mappaAnalysisQueryPoints?.props?.pointStyle || "YellowPoint";

        if (qp.analysis_id == null) {
          feature.setProperties({ kml_marker: true });
        }

        feature.setStyle(
          this.servizioMappa.buildFeatureStyleFromId(featureStyle)
        );
        feature.setId(qp.id);

        this.mappa.aggiungiFeature(
          this.mappa.layerAnalysisQueryPoints,
          feature
        );

        const tooltipColor =
          mappaAnalysisQueryPoints?.props?.tooltipColor || "#00BBFF";
        const tooltipTextColumn =
          mappaAnalysisQueryPoints?.props?.tooltipTextColumn || "id";

        const overlay = this.analysisUtilsService.createPointTooltip(
          String(qp[tooltipTextColumn]),
          point.getCoordinates(),
          tooltipColor
        );

        feature.set("overlay", overlay);
        this.mappa.insertOverlay(overlay);
      }
    });
  }

  /** gestione della barra di scorrimento laterale */
  ngAfterViewInit() {
    this.elementRef.nativeElement.ownerDocument.body.style.overflow = "hidden";
  }

  /** OnDestroy */
  ngOnDestroy() {
    this.elementRef.nativeElement.ownerDocument.body.style.overflow = "unset";
    if (this.initSubscription) {
      this.initSubscription.unsubscribe();
    }
    if (this.initSubscriptionData) {
      this.initSubscriptionData.unsubscribe();
    }

    if (!!this.sizeObserver) {
      this.sizeObserver.disconnect();
    }
    this.subs.forEach((s) => s.unsubscribe());

    this.wrapperMapService.mapReady.next(false);

    this.servizioMappa.clearServiceVar();
  }

  routerSubscribe(data: any) {
    if (data && Object.keys(data).length !== 0) {
      if (data.login) {
        this.login = data.login;
      } else {
        this.mapInputData = data;

        if (!this.mapInputData.controlliMappaAttivi) {
          this.controlliMappaAttivi = this.mapInputData.controlliMappaAttivi;
        }
        this.showBackButton = true;

        if (!!this.mappa && this.mappa._mappaPronta) {
          this.gestisciAzioniMappa();
          this.showBackButton = false;
        }
      }
    }
  }

  /** Inizializza le configurazioni e aggiunge i layers alla mappa quando questa è pronta */
  onMapReady() {
    //Send the MapComponent to the global service to be able to use the map everywhere.
    this.wrapperMapService.mappa = this.mappa;

    if (ContextProvider.getContext().context.application != "NAM") {
      this.configMappa.wmsLayers
        .filter((layer) => layer.posizione === PosizioneLayer.OVERLAY)
        .forEach((layerJSON) => {
          const layer = this.mappa.creaLayerWMS(layerJSON);
          this.mappa.aggiungiLayerAllaMappa(layer);
        });
      this.configMappa.wmtsLayers
        .filter((layer) => layer.posizione === PosizioneLayer.OVERLAY)
        .forEach((layerJSON) => {
          const layer = this.mappa.creaLayerWMTS(layerJSON);
          this.mappa.aggiungiLayerAllaMappa(layer);
        });
      this.configMappa.xyzLayers
        .filter((layer) => layer.posizione === PosizioneLayer.OVERLAY)
        .forEach((layerJSON) => {
          const layer = this.mappa.creaLayerXYZ(layerJSON);
          this.mappa.aggiungiLayerAllaMappa(layer);
        });
      this.configMappa.vectorLayers
        .filter((layer) => layer.posizione === PosizioneLayer.OVERLAY)
        .forEach((layerJSON) => {
          const layer = this.mappa.createLayerVector(layerJSON);
          this.mappa.aggiungiLayerAllaMappa(layer);
        });
    }

    // Aggiunge la visibilità dei layer alla sessione
    const session: {
      tab: string;
      title: string;
      layer: string;
      visibility: boolean;
      opacity: number;
    }[] = [];

    const defaultContent = this.configMappa.sceltaRappresentazione;

    this.mappa.mappaOpenLayer
      .getLayers()
      .getArray()
      .forEach((baseLayer: BaseLayer) => {
        defaultContent.forEach((tab) => {
          if (true) {
            tab.content.forEach((group) => {
              if (
                group.values.findIndex(
                  (el) =>
                    el ===
                    baseLayer.getProperties()[MapService.TITOLO_LAYER_KEY]
                ) >= 0
              ) {
                session.push({
                  tab: tab.tab_id,
                  title: group.group_name,
                  layer: baseLayer.getProperties()[MapService.TITOLO_LAYER_KEY],
                  visibility:
                    baseLayer.getProperties()[MapService.VISIBILITA_LAYER_KEY],
                  opacity:
                    baseLayer.getProperties()[MapService.OPACITA_LAYER_KEY]
                });
              }
            });
          }
        });
      });

    // imposto il listener per il resize della mappa
    this.sizeObserver = new ResizeObserver(() => {
      this.mappa.mappaOpenLayer.updateSize();
    });
    this.sizeObserver.observe(this.mappa.olmapdiv.nativeElement);

    // Se ci sono layers in sessione, controllo se devono essere abilitati
    let sessionLayers =
      JSON.parse(sessionStorage.getItem("layer_attivi")) == null
        ? []
        : JSON.parse(sessionStorage.getItem("layer_attivi"));
    if (sessionLayers.length > 0) {
      this.mappa.layerAggiornati(sessionLayers);
    }

    // Se sono presenti dei dati di input
    if (!!this.mapInputData && Object.keys(this.mapInputData).length > 0) {
      this.gestisciAzioniMappa();
    }

    this.subscriptions();
    this.wrapperMapService.mapReady.next(true);
  }

  private setSourceToStaticImageLayer(
    apiConfig: ConfigApiInterface,
    worldInfo: WorldInfoInterface,
    objectUrn: string
  ) {
    const staticImageLayer = this.mappa?.mappaOpenLayer
      ?.getLayers()
      .getArray()
      .find(
        (l) => l.get(MapService.TITOLO_LAYER_KEY) === "object_static_image_draw"
      );

    if (staticImageLayer !== undefined) {
      // Fetch the base url.
      let baseUrl: string = apiConfig.data.layers[0].layers[0].url;
      baseUrl += this.projectService.hasProject
        ? "&project_id=" + this.projectService.projectId
        : "";
      let worldLayerSource = createStaticImageLayerSource(
        objectUrn,
        baseUrl,
        worldInfo,
        this.utils.loaderf
      );

      //Add the imageloadstart to put the loading spinner when the layer starts loading
      worldLayerSource.on("imageloadstart", (event) => {
        this.loaderService.isLoading.next(true);
      });

      //Add the imageloadend to hide the loading spinner when the layer finishes loading.
      //Fits the view after loading for a smoother effect when changing worlds.
      worldLayerSource.on("imageloadend", (event) => {
        this.loaderService.isLoading.next(false);
        //
      });

      //Hides the spinner in case the image was not loaded
      worldLayerSource.on("imageloaderror", (event) => {
        this.loaderService.isLoading.next(false);
      });

      this.mappa.mappaOpenLayer.getView().fit(extentFromWorldInfo(worldInfo));
      (staticImageLayer as Layer).setSource(worldLayerSource);
    }
  }

  gestisciAzioniMappa() {
    switch (this.mapInputData.mapAction) {
      /** Centrare la mappa sulla geometria */
      case "fit":
        if (this.mapInputData.geom) {
          var geom: Geometry | Geometry[];
          /** Il cerchio va gestito diversamente, per il posizionamento è sufficiente recuperarne il centro */
          /** Sono stati gestiti i cerchi che vengono 'inviati' dalla modale nella sezione modifica del portale delle
               ordinanze, quindi viene gestito il formato dell'oggetto che arriva da questo componente (ordinanze -> map-modal-component)*/
          // Circle
          if (
            !!this.mapInputData.geom.type &&
            this.mapInputData.geom.type == "Circle"
          ) {
            geom = new Point(this.mapInputData.geom.coordinates);
          }
          // Other Geometries
          else {
            geom = new GeoJSON().readGeometry(this.mapInputData.geom, {
              dataProjection: this.mapInputData.geom.crs?.properties?.name
                ? this.mapInputData.geom.crs.properties.name
                : MapService.EPSG_3857_KEY,
              featureProjection: MapService.EPSG_3857_KEY
            });
          }

          // Feature style
          const feature = new Feature({ geometry: geom });
          const style = this.servizioMappa.buildFeatureStyleFromId("BlueFill");

          feature.setStyle(style);

          this.mappa.aggiungiFeature(this.mappa.layerDisegno, feature);

          // Fit
          this.mappa.viewMappa.fit(geom as SimpleGeometry);

          if (this.mappa.viewMappa.getZoom() > 18) {
            this.mappa.viewMappa.setZoom(18);
          }
        }

        break;

      default:
        break;
    }

    // aggiorna la visibilità layers che potrebbero essere stati modificati prima di aprire la mappa
    // GB this.mappa.layerAggiornati(this.servizioMappa.layers);
  }

  /**
   * Cambia la visibilità del layer
   * @param   layer layer a cui cambiare la visibilità
   */
  cambiaStatoLayer(layer: BaseLayer) {
    console.log("++++++ cambiaStatoLayer", layer);
    this.mappa.cambiaVisibilitaLayer(layer, !layer.getVisible());
  }

  chiudiObj(obj: Feature) {
    // console.log("spec --> chiudi", obj);
  }

  modificaObj(obj: Feature) {
    // console.log("spec --> modifica", obj);
  }

  /**
   * Apertura Report dell'oggetto selezionato
   */
  visualizzaObj(obj: Feature) {
    if (this.reportIsOpen) {
      return;
    }

    var params = new HttpParams();
    var url;

    const properties = obj.getProperties();
    const urn = obj.getId();

    url = this.loginService.creaURL("restrictedArea", "reportByUrn");

    params = params.set("urn", urn.toString());

    const opt = { ...this.getAuthorizationHeader(), params: params };

    // in caso voglia visualizzare un'analisi non faccio la chiamata reportByUrn perchè ho tutte le proprietà che mi servono
    if (properties.report === "analysis") {
      this.visualizzaObjContinue(properties.report, urn, properties);
      return;
    }

    // ReportByUrn
    this.http.get(url, opt).subscribe({
      next: (response) => {
        this.visualizzaObjContinue(properties.report, urn, response);
      },
      error: (error) => {
        console.error("Get request error", error);
      }
    });
  }

  visualizzaObjContinue(report, urn, data) {
    console.log("report : ", report);

    switch (report) {
      // Report OMI
      case "omi":
        const omi_report = this.modal.open(ReportOmiComponent, {
          ariaLabelledBy: "modal-basic-title",
          centered: true,
          size: "xl"
        });

        omi_report.componentInstance.obj = data;
        omi_report.componentInstance.id = urn;

        break;

      // Report BTS
      case "bts":
        const bts_report = this.modal.open(ReportBtsComponent, {
          ariaLabelledBy: "modal-basic-title",
          centered: true,
          size: "md"
        });

        bts_report.componentInstance.obj = data;
        bts_report.componentInstance.id = urn;
        break;


      case "analysis":
        let analysisModal = this.modalService.open(
          AnalysisPropertyModalComponent,
          { ariaLabelledBy: "modal-basic-title", size: "l" }
        );
        analysisModal.componentInstance.data = data;
        analysisModal.componentInstance.data.id = urn.match(/\d+/g)[1];
        // analysisModal.result.finally(() => analysisModal = null);

        break;

      default:
        break;
    }
  }

  private getAuthorizationHeader() {
    return {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.loginService.getToken(),
        "Content-Type": "application/x-www-form-urlencoded"
      })
    };
  }

  /**
   * Funzione per tornare alla pagina di ricerca dopo un posizionamento
   *
   */
  onBackButtonClick() {
    this.routerSrv.navigateToChild(
      this.mapInputData.backPath,
      this.mapInputData
    );
  }

  chiudiToolDisegnoDaComponenteEsterno(evt: any) {

    // Per completare le chiusura del tool disegno facendo Apri/Chiudi dal pulsante Disegna Area senza
    // aver confermato alcuna nuova geometria
    if (evt === true) {
      // Per chiudere il tool di disegno da map.component
      this.mappa.gestisciChiudiToolDisegno(true);

      // TODO per analysis add

      // Per reimpostare  this.selectDraw = false in analysis-edit-area.component
      this.wrapperMapService.chiudiToolDisegno.next(true);
    }
  }

  gestisciChiusuraToolDisegno(evt: any) {
    // Per completare le chiusura del tool disegno dopo conferma geometria(analysis-edit-area)
    if (evt === true) {
      // Per reimpostare  this.selectDraw = false in analysis-edit-area.component
      this.wrapperMapService.chiudiToolDisegno.next(true);
    }

    // Se necessario emettere l'elemento confermato alla modale esterna -> map-modal.component
    if (!!evt && !!evt.type) {
      this.toolDisegnoChiusuraMappaEmitter.emit(evt);
    }
  }

  /** Gestisce l'elemento restituito dal tool di disegno
   *
   *  evt = {
   *    geom: geoJsonGeom,
   *    type: this.currentObjType,
   *    currentObj: this.currentObj
   *  };
   */
  gestisciElementoConfermato(evt: any) {
    if (!!evt) {
      this.toolDisegnoElementoConfermatoMappaEmitter.emit(evt);
      this.broadcastGeometryFromDrawTool(evt);
      this.wrapperMapService.drawingToolFeaturesSubject.next(evt)
    }
  }

  private broadcastGeometryFromDrawTool(evt: any) {
    if (evt?.geom?.type && evt?.geom?.coordinates) {
      // console.log('point evt?.geom?.coordinates: ',evt?.geom?.coordinates);
      this.analysisDataLoaderService.broadcastDrawToolGeometry(evt);
    }
  }

  getElementoDisegnoConfermato(evt: any) {
    let res: any;
    if (!!evt) {
      //  switch (evt) {
      //     // case 'oggetto':
      //     //    this.oggettiComponent.gestisciElementoConfermato(evt);
      //     //    break;
    }
    return res;
  }

  /** Per aprire il tool di disegno dall'esterno passando l'oggetto da gestire */
  /**
   * @param obj  Oggetto da gestire (ingiunzione, occupazione, vincoli, ecc..) o evento (booleano) di apertura/chiusura del pannello (controlli mappa)
   * @param type tipo dell'oggetto da gestire, ed esempio : Ingiunzione, occupazione, ecc..
   * @param defaultTool Parametro opzionale che indica se il tool di disegno deve essere aperto con un strumento preselezionato
   * @param closeAll Parametro opzionale che indica se i pulsanti 'Annulla' e 'X' devono chiudere sia il pannello delle coordinate che la toolbar
   * @param data Dati aggiuntivi
   */
  gestisciToolDisegno(
    obj: any,
    type: any,
    defaultTool?: any,
    closeAll?: any,
    data?: any,
    enabledTools?: ToolDisegnoEnabledToolsInterface
  ) {

    // console.log(`MAPPA-COMPONENT (gestisciToolDisegno):
    //   obj: ${obj}
    //   type: ${type}
    //   defaultTool: ${defaultTool}
    //   closeAll: ${closeAll}
    //   data: ${data}
    //   enabledTools: ${enabledTools}
    //   `)
    this.mappa.gestisciToolDisegno(
      obj,
      type,
      defaultTool,
      closeAll,
      data,
      enabledTools
    );
  }

  /** Metodo usato per calcolare la superficie di una geometria */
  calcolaSuperficie(geom: any) {
    return this.mappa.calcolaSuperficie(geom);
  }

  /** Per evidenziare la geometria delle particelle sulla mappa (riconsegna totale e parziale) */
  tematizzaArea(geoms: any) {
    this.mappa.tematizzaArea(geoms);
  }

  /** Per ripulire un layer */
  pulisciLayer(layerName: any) {
    this.mappa.pulisciLayer(layerName);
  }

  /** Refresh layer */
  refreshLayer(layerName: string) {
    this.mappa.refreshLayer(layerName);
  }

  /** Disegna le geometrie sulla mappa
   * Le Geometrie delle occupazioni sono geometrie puntuali
   * @param obj array di occupazioni da visualizzare
   * @param type indica il tipo della feature da caricare, ad esempio occupazioni, ingiunzioni, oggetti, ecc..
   */
  caricaFeatures(obj: any, type: any) {
    let geom;

    obj.forEach((el) => {
      if (!!geom) {
        let feat;

        // Da MultiPolygon a Polygon (il tool di disegno gestisce i Polygon)
        if (!!geom.getType() && geom.getType() === "MultiPolygon") {
          const tmp = geom.getPolygons()[0];
          feat = new Feature({ geometry: tmp });
        } else {
          feat = new Feature({ geometry: geom });
        }

        feat.setStyle(this.servizioMappa.buildFeatureStyleFromId("BlueFill"));
        feat.setId(el.id);

        this.mappa.aggiungiFeature(this.mappa.layerDisegno, feat);
      }
    });
  }

  /** Disegna ogni oggetto sulla mappa
   * @param obj array di oggetti da visualizzare
   */
  caricaOggetti(obj) {
    // obj.forEach((el) => {
    //    if (el.geometria_oggetto) {
    //       const geom = new GeoJSON().readGeometry(el.geometria_oggetto, {
    //          dataProjection: MapService.EPSG_3857_KEY,
    //          featureProjection: MapService.EPSG_3857_KEY
    //       }) as SimpleGeometry;
    //       /**
    //        * Se è una variazione geometrica voglio fare il fit senza vedere il disegno
    //        * perché lo gestisco nel tool di disegno
    //        */
    //       let feat;
    //       // Da MultiPolygon a Polygon (il tool di disegno gestisce i Polygon)
    //       if (geom.getType() === 'MultiPolygon') {
    //          const tmp = (geom as MultiPolygon).getPolygons()[0];
    //          feat = new Feature({ geometry: tmp });
    //       } else {
    //          feat = new Feature({ geometry: geom });
    //       }
    //       feat.setStyle(this.servizioMappa.buildFeatureStyleFromId('BlueFill'));
    //       feat.setId(el.id);
    //       this.mappa.aggiungiFeature(this.mappa.layerDisegno, feat);
    //    }
    // });
  }

  onGeometryChanged(evt) {
    this.geometryChanged.emit(evt);
  }

  /**
   * Metodo per aggiungere un punto nella mappa
   * @param coordinate [x, y] coordinate del punto
   * @param icon path dell'icona
   * @param label testo
   */
  aggiungiPunto(coordinate, icon, label) {
    const iconFeature = new Feature({
      geometry: new Point(coordinate)
    });

    const stroke = new Stroke({ color: "#E600FF", width: 2 });

    const iconStyle = [
      new Style({
        image: new RegularShape({
          // fill: fill,
          stroke,
          points: 4,
          radius: 10,
          radius2: 0,
          angle: 0
        })
      }),
      new Style({
        text: new Text({
          text: label,
          offsetY: -10,
          font: "Bold 15px Arial",
          fill: new Fill({
            color: "#0000FF"
          })
        })
      })
    ];
    iconFeature.setStyle(iconStyle);
    this.rilievoOverlay.getSource().addFeatures([iconFeature]);

    return iconFeature;
  }

  /**
   * Metodo per inserire il disegno di una linea
   * @param coordinate [[x, y], [x, y]] coordinate del punto
   */
  aggiungiLinea(coordinate) {
    const stroke = new Stroke({ color: "green", width: 2 });

    const lineStyle = [
      new Style({
        stroke
      })
    ];
    const lineFeature = new Feature({
      geometry: new LineString(coordinate),
      name: "linea"
    });
    lineFeature.setStyle(lineStyle);
    this.rilievoOverlay.getSource().addFeatures([lineFeature]);
  }

  /**
   * Metodo per disegnare cerchio
   * @param coordinate [x, y] coordinate del punto
   * @param icon path per l'icona
   * @param label testo
   * @param raggio raggio
   * @param resolution
   */
  aggiungiCerchio(coordinate, icon, label, raggio, resolution) {
    let rd = Math.floor(parseInt(raggio) / 1000);
    if (rd < 1) {
      rd = 1;
    }
    coordinate = [parseFloat(coordinate[0]), parseFloat(coordinate[1])];

    // **AGGIUSTAMENTO PER DISEGNARE UN CERCHIO CON RAGGIO IN METRI
    const view = this.mappa.mappaOpenLayer.getView();
    const projection = view.getProjection();
    const resolutionAtEquator = view.getResolution();
    const pointResolution = getPointResolution(
      projection,
      resolutionAtEquator,
      coordinate
    );
    const resolutionFactor = resolutionAtEquator / pointResolution;
    rd = (rd / METERS_PER_UNIT.m) * resolutionFactor;

    const iconFeature = new Feature({
      geometry: new Circle(coordinate, rd)
    });

    const iconStyle = [
      new Style({
        fill: new Fill({ color: [0, 255, 0, 0.1] }),
        stroke: new Stroke({ color: [0, 255, 0, 1], width: 2 })
      }),
      new Style({
        text: new Text({
          text: label,
          offsetY: -10,
          font: "Bold 15px Arial",
          fill: new Fill({
            color: "#0000FF"
          })
        })
      })
    ];

    iconFeature.setStyle(iconStyle);
    this.rilievoOverlay.getSource().addFeatures([iconFeature]);
  }

  /**
   * Metodo chiamato quando viene emesso l'evento mapSidebarStateEmitter
   */
  public handleMapSidebar(event) {
    if (
      event.sidebarOpen &&
      event.menuState === "out" &&
      this.router.url.includes("sidebar")
    ) {
      this.router.navigate(["/mappa"]);
    }
  }

  /**
   * Quando clicco su una voce di menù che utilizza la rightsidebar,
   * se già aperta devo chiudere la sidebar prima di aprirla per il nuovo componente
   */
  public toggleSidebarAnalysis(data) {
    var toggle = false;

    Object.keys(this.mappa.pannelliSidebar).forEach((key) => {
      // Il tool di disegno non apre la sidebar quindi il toggle non va fatto
      if (this.mappa.pannelliSidebar[key] && key != "disegno") {
        toggle = true;
      }

      this.mappa.pannelliSidebar[key] = false;
    });

    if (toggle) {
      this.mappa.toggleSidebar();
    }
  }

  /** Per illuminare le features */
  public illuminaFeature(obj) {
    // console.log("+++++ 3- MAPPA.C >> MAP-SERVICE ILLUMINA.NEXT");

    // Map
    this.servizioMappa.illuminaFeatureSub.next(obj);
  }

  /** Per spegnere le features */
  public spegniFeature(obj) {
    // console.log("----- 3- MAPPA.C >> MAP-SERVICE ILLUMINA.NEXT");

    // Map
    this.servizioMappa.spegniFeatureSub.next(obj);
  }

  // StreetView
  /** Per Aprire Google Street View da un qualunque componente del portale */
  toggleStreetView(obj) {
    this.servizioMappa.toggleStreetViewSubject.next(obj);
  }

  // StreetView butotn hide/show
  /** Per nascondere/mostrare il pulsante Google Street View */
  isStreetViewVisible(data) {
    this.servizioMappa.isStreetViewVisibleSubject.next(data);
  }

  /** per definire le configurazioni da passare alla libreria map */
  configureMap() {
    const centro3857 = transform(
      this.configMappa.mapSetup.coordinate,
      MapService.EPSG_4326_KEY,
      MapService.EPSG_3857_KEY
    );

    this.customCenterCoords = centro3857;

    //console.log("this.configMappa.worldLayers", this.configMappa.worldLayers)
    this.options = {
      googleKeyType: "",
      googleKey: "",
      layers: {
        mapBaseLayersActive:
          this.gestioneUtentiService.isEnabled(
            this.configGlobale.permissions.mapControls.mapBaseLayers
          ) && ContextProvider.getContext().basemapSelector,
        positionLayersControl: this.configMappa.layers.positionLayersControl,
        layersWorld: this.configMappa.worldLayers,
        layersWMS: this.configMappa.wmsLayers,
        layersXYZ: this.configMappa.xyzLayers,
        layersVector: this.configMappa.vectorLayers
      },
      centroMappa4326: this.configMappa.mapSetup.coordinate,
      zoom: this.configMappa.mapSetup.zoom,
      zoomMinimo: this.configMappa.mapSetup.zoomMinimo,
      zoomMassimo: this.configMappa.mapSetup.zoomMassimo,
      infoView: {
        infoMapActive:
          this.gestioneUtentiService.isEnabled(
            this.configGlobale.permissions.mapControls.mapInfo
          ) && ContextProvider.getContext().coordinates,
        arrotondamentoInfoVista: this.configMappa.infoViewSetup.round,
        positionInfoView: this.configMappa.infoView.positionInfoView
      },
      search: {
        mapSearchPanelActive:
          this.gestioneUtentiService.isEnabled(
            this.configGlobale.permissions.mapControls.mapSearchPanel
          ) && ContextProvider.getContext().ricercaIndirizi,
        positionGoogleSearch: this.configMappa.search.positionGoogleSearch
      },
      legend: {
        legendActive:
          this.gestioneUtentiService.isEnabled(
            this.configGlobale.permissions.mapAdvancedControls.mapAdvancedLegend
          ) && ContextProvider.getContext().legenda
      },
      preview: {
        previewMapActive:
          this.gestioneUtentiService.isEnabled(
            this.configGlobale.permissions.mapControls.mapPreview
          ) && ContextProvider.getContext().minimap,
        idStilePreview: this.configMappa.mapPreviewSetup.stile,
        altezzaPreview: this.configMappa.mapPreviewSetup.altezza,
        larghezzaPreview: this.configMappa.mapPreviewSetup.larghezza,
        sogliaZoomPreview: this.configMappa.mapPreviewSetup.sogliaZoom,
        positionPreviewMap: this.configMappa.preview.positionPreviewMap
      },
      mapChecks: {
        positionMapChecks: this.configMappa.mapCheck.positionMapChecks,
        controlliMappaAttivi:
          this.gestioneUtentiService.isEnabled(
            this.configGlobale.permissions.mapControls.mapBaseControls
          ) && ContextProvider.getContext().mapBaseControls,
        selezioneOggettiAttiva: true,
        drawingToolActive:
          this.gestioneUtentiService.isEnabled(
            this.configGlobale.permissions.mapAdvancedControls
              .mapAdvancedDrawingTool
          ) && ContextProvider.getContext().toolDisegno,
        reprChoiceActive:
          this.gestioneUtentiService.isEnabled(
            this.configGlobale.permissions.mapAdvancedControls
              .mapAdvancedRepresentationChoice
          ) && ContextProvider.getContext().sceltaRappresentazione,
        transformCoordsActive:
          this.gestioneUtentiService.isEnabled(
            this.configGlobale.permissions.mapAdvancedControls
              .mapAdvancedTransformCoords
          ) && ContextProvider.getContext().transformaCoordinate
      },
      urlBackendAPI: "api",
      defaultSR: this.configMappa.defaultSR,
      arraySR: this.configMappa.arraySR,
      contentSceltaRappresentazione: this.configMappa.sceltaRappresentazione
    };
  }

  private _getAnalysisLegend() {
    this.analysisLegendService.getAnalysesLegend().subscribe({
      next: (res) => {
        if (!res || res.error !== 0) {
          this.ebwModalService.openErrorModal({
            title: "Errore",
            content: "Errore recupero dati: " + res.errorDescription
          });

          return;
        }
        if (this.configMappa && this.configMappa.legenda) {
          const inwitTab = this.configMappa.legenda.find(
            (_) => _.nome_tab === "INWIT"
          );
          const { layers: inwitLayers } = inwitTab
            ? inwitTab.content.find((_) => _.group_name === "INWIT_L")
            : null;

          if (inwitLayers) {
            const analysisAreas = inwitLayers.find(
              (_) => _.layer_name === "AnalysisAreas"
            );
            if (analysisAreas) {
              analysisAreas.legenda = analysisAreas.legenda.filter(
                (ele: any) => !ele.isFromDb
              );
              analysisAreas.legenda = analysisAreas.legenda.concat(
                res.data.map((_) => ({
                  descrizione: `${_.piano_lavori} - ${_.anno_lavori} ${_.descrizione ? "- " + _.descrizione : ""
                    }`,
                  path: "",
                  color: _.colore,
                  //controllo dato da db o locale
                  isFromDb: true
                }))
              );
            }
          }
        }

        this.analysisLegendService.analysisLegend$.next(res.data);
      },
      error: (error) => {
        this.ebwModalService.openErrorModal({
          title: "Errore",
          content: "Errore recupero dati legenda"
        });
      }
    });
  }


}
